import { format, isThisYear } from 'date-fns'

import { DATE_FORMATS } from 'utils/constants'
import { getDateFormatLocale } from 'utils/getDateFormatLocale'

export const formatItemCardDate = (dateString: string): string => {
  const date = new Date(dateString)

  return formatItemCardDateDate(date)
}

export const formatItemCardDateDate = (date: Date): string => {
  return format(date, isThisYear(date) ? DATE_FORMATS.noYearDate : DATE_FORMATS.fullDate, {
    locale: getDateFormatLocale(),
  })
}

export const formatItemCardOnlyDate = (date: Date): string => {
  return format(date, isThisYear(date) ? DATE_FORMATS.noYearOnlyDate : DATE_FORMATS.fullOnlyDate, {
    locale: getDateFormatLocale(),
  })
}
